import React from 'react';
import { mergeClassNames } from '../../../../../../utils';
import styles from './index.module.scss';

export default function WarningLabel({ caption }) {
  return (
    <div className={mergeClassNames([styles.warningLabel, 'label'])}>
      <span>{caption}</span>
    </div>
  );
}
